!(function () {
  'use strict';
  customElements.get('announcement-bar') ||
    customElements.define(
      'announcement-bar',
      class extends HTMLElement {
        constructor() {
          super();
          this.barHolder = this;
          this.locationPath = location.href;
          this.slides = this.barHolder.querySelectorAll('[data-slide]');
          this.slider = this.barHolder.querySelector('[data-slider]');
          this.static = this.barHolder.querySelector('[data-static]');
          this.parallax = this.barHolder.querySelector('[data-parallax-animation]');
          this.flkty = null;
          this.autoplayTimer = null;
          this.isInteracting = false;
        }

        connectedCallback() {
          this.removeAnnouncement();
          this.checkSlidesClasses();
          if (this.slider) {
            this.initSlider();
            this.boundInit = this.initSlider.bind(this);
            document.addEventListener('theme:resize:width', this.boundInit);
          }
          this.updateSVGClipPathIDs();
        }

        removeAnnouncement() {
          for (let e = 0; e < this.slides.length; e++) {
            const t = this.slides[e];
            t.hasAttribute('data-target-referrer') &&
              (-1 !== this.locationPath.indexOf(t.getAttribute('data-target-referrer')) ||
                window.Shopify.designMode ||
                t.parentNode.removeChild(t));
          }
        }

        checkSlidesClasses() {
          if (0 !== this.slides.length) {
            const e = this.barHolder.querySelectorAll('[data-slide].mobile'),
              t = this.barHolder.querySelectorAll('[data-slide].desktop');
            this.slides.length === e.length
              ? this.barHolder.parentNode.classList.add('mobile')
              : this.slides.length === t.length && this.barHolder.parentNode.classList.add('desktop');
          }
        }

        initSlider() {
          const slides = this.slider.querySelectorAll('[data-slide]');
          const showArrows = this.slider.hasAttribute('data-slider-arrows');
          if (!slides) return;

          const cellSelector =
            window.innerWidth < theme.sizes.small
              ? '[data-slide]:not(.desktop)'
              : '[data-slide]:not(.mobile)';

          if (null != this.flkty) this.flkty.destroy();

          this.flkty = new window.theme.Flickity(this.slider, {
            cellSelector: cellSelector,
            pageDots: !1,
            prevNextButtons: showArrows,
            wrapAround: !0,
            // Isolate the announcement carousel from the site's RTL direction.
            // The whole site sets document.dir="rtl", and vendor.js patches
            // Flickity's default to rightToLeft:true — which makes autoPlay and
            // .next() unreliable (they become no-ops / never advance, especially
            // on mobile after the first touch). Forcing LTR here makes rotation
            // work again. This only controls the slide-advance direction; the
            // Hebrew text inside each slide stays RTL (governed by page CSS).
            rightToLeft: !1,
            // Disable Flickity's native autoplay — in this setup it never ran
            // reliably and a single touch on mobile killed it permanently. We
            // drive rotation manually in startAutoplay() instead.
            autoPlay: !1,
            on: {
              ready: () => {
                setTimeout(() => this.refresh(), 10);
              },
              change: (index) => {
                this.flkty.cells.forEach((cell, i) => {
                  cell.element.querySelectorAll('text-highlight').forEach((el) => {
                    el.setTriggerAttribute(Boolean(i === index));
                  });
                });
              },
            },
          });

          this.flkty.reposition();
          this.startAutoplay();
        }

        // Manual, RTL-independent autoplay. Advances one slide every
        // data-slider-speed ms, pausing only while the user is actively
        // dragging and while the tab is hidden. Because it never "stops" on a
        // tap (it just skips ticks during a drag), the mobile touch-stops-
        // autoplay-forever bug cannot happen.
        startAutoplay() {
          this.stopAutoplay();
          if (!this.flkty) return;

          const speed = parseInt(this.slider.getAttribute('data-slider-speed'), 10);
          const cellCount = this.flkty.cells ? this.flkty.cells.length : 0;
          if (!speed || cellCount < 2) return;

          this.isInteracting = false;
          const pause = () => {
            this.isInteracting = true;
          };
          const resume = () => {
            this.isInteracting = false;
          };
          this.flkty.on('dragStart', pause);
          this.flkty.on('pointerDown', pause);
          this.flkty.on('dragEnd', resume);
          this.flkty.on('settle', resume);
          this.flkty.on('staticClick', resume);

          this.autoplayTimer = setInterval(() => {
            if (document.hidden || this.isInteracting) return;
            try {
              this.flkty.next(!0);
            } catch (e) {}
          }, speed);
        }

        stopAutoplay() {
          if (this.autoplayTimer) {
            clearInterval(this.autoplayTimer);
            this.autoplayTimer = null;
          }
          this.isInteracting = false;
        }

        refresh() {
          this.querySelectorAll('ticker-bar')?.forEach((e) => {
            'function' == typeof e.resizeEvent && e.resizeEvent();
          });
          this.updateSVGClipPathIDs();
        }

        updateSVGClipPathIDs() {
          this.barHolder.querySelectorAll('[data-slide]').forEach((e, t) => {
            const i = e.querySelector('clipPath');
            if (i) {
              const s = `${i.id}_${t}`;
              i.id = s;
              const l = e.querySelector('g[clip-path]');
              l && l.setAttribute('clip-path', `url(#${s})`);
            }
          });
        }

        disconnectedCallback() {
          this.stopAutoplay();
          if (this.boundInit) document.removeEventListener('theme:resize:width', this.boundInit);
        }
      }
    );
})();
